import { useSearchParams } from 'react-router-dom';

import { ITabsProps, Tabs } from './Tabs';

interface IProps extends ITabsProps {
  searchParamKey?: string;
}

export const PageTabs = ({
  searchParamKey = 'tab',
  defaultTab: defaultTabProp,
  ...tabsProps
}: IProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultTab = searchParams.get(searchParamKey) || defaultTabProp;

  const onTabChange = (value: string | number) => {
    setSearchParams({ [searchParamKey]: value.toString() });
  };

  return <Tabs defaultTab={defaultTab} onChange={onTabChange} {...tabsProps} />;
};
